import React, { useEffect, useState } from "react";
import Footer from "../../Components/Footer/footer";
import { LuMail } from "react-icons/lu";
import StepRoutes from "../../Routes/steps_routes";
import DynamicFilterSelect from "../../Components/layouts/filter.select";
import DynamicFilterInput from "../../Components/layouts/filter.inpit";
import Pagination from "../../Components/layouts/pagination";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import WhatsAppButton from "../../Components/layouts/whatsApp_button";
import MarketingTable from "./Marketing List/marketing_table";
import { useLocation, useNavigate } from "react-router";
import LoadingPage from "../../Components/layouts/loading";
import { PiListFill} from "react-icons/pi"

const MarketingSystem = () => {
  const [refresh, setRefresh] = useState(false);

  const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const pageFromURL = parseInt(queryParams.get("page")) || 1;
    const [page, setPage] = useState(pageFromURL);

  // const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [btnDisable, setBtnDisable] = useState(false);
  const [filterCount, setFilteredCount] = useState("");
  const [totalCount, setTotalCount] = useState("");
  const Navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    origin: "",
    isEmail: false,
    isMobile: false,
  });

   useEffect(() => {
      navigate(`?page=${page}`, { replace: true });
    }, [page, navigate]);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", getFilteredURL("marketingList/getMl", page, filters))
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          if (!filters.origin) {
            setTotalPages(Math.ceil(res.data.marketingListsTotalCount / 50));
          } else {
            setTotalPages(Math.ceil(res.data.filterMarketingListCount / 50));
          }
          setFilteredCount(res.data.filterMarketingListCount);
          setTotalCount(res.data.marketingListsTotalCount);
          setLoading(false);
        } else {
          Toast("error", "Error while getting Quotations!");
          setLoading(false);
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [refresh, page]);

  const handleDownloadCSV = () => {
    setBtnDisable(true);
    performRequest(
      "GET",
      getFilteredURL("marketingList/getMarketingCsvData", page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          let fileName = "";
          if (filters.origin) {
            fileName = filters.origin;
          } else {
            fileName = "All_Marketing_List";
          }
          const csvData = res.data; // This is the plain text CSV data
          const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${fileName}.csv`); // Specify the file name
          document.body.appendChild(link);
          link.click();
          link.remove(); // Clean up
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setBtnDisable(false));
  };

  const handleSendEmail = () => {
    if (filters.isEmail === true) {
      Navigate(
        `/email-marketing?origin=${filters.origin ?? ""}&isEmail=${
          filters.isEmail
        }`
      );
    } else {
      Toast("error", "Please Select Email");
    }
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div style={{ minHeight: "80vh" }}>
          <div className="page-header d-print-none">
            <div className="container-xl">
              <div className="row g-2 align-items-center">
                <div className="col">
                  <h2 className="page-title"> 
                  <PiListFill className="fs-2 me-1"  style={{ color: "green" }} />Marketing List</h2>
                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>
                <div className="col-auto ms-auto d-print-none">
                  <div className="d-flex d-none d-sm-block">
                    <button
                      onClick={handleSendEmail}
                      className="btn btn-danger me-3 mt-2"
                    >
                      <LuMail className="fs-2 me-1" />
                      Send Email
                    </button>
                    <WhatsAppButton buttonText="Send Whatsapp" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="container-xxl">
              <div className="row">
                <div className="col-md-3 col-sm-12 py-2">
                  <div className="card p-2">
                    <div
                      id="faq-1"
                      className="accordion"
                      role="tablist"
                      aria-multiselectable="true"
                    >
                      <div>
                        <div className="accordion-header m-0" role="tab">
                          <button
                            className="accordion-button fs-3 d-md-none p-0"
                            data-bs-toggle="collapse"
                            data-bs-target="#faq-1-1"
                          >
                            <h3 className="m-1">Filter result</h3>
                          </button>
                        </div>

                        <div
                          id="faq-1-1"
                          className="accordion-collapse collapse d-md-none"
                          role="tabpanel"
                          data-bs-parent="#faq-1"
                        >
                          <div className="accordion-body pt-0">
                            <div className="row">
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Start Date:"
                                  value={filters.startdate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      startdate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="End Date:"
                                  value={filters.enddate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      enddate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Origin:"
                                  value={filters.origin}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      origin: e.target.value,
                                    })
                                  }
                                  placeholder="search name..."
                                >
                                  <option value="">Select</option>
                                  <option value="Facebook Ads">
                                    Facebook Ads
                                  </option>
                                  <option value="Just Dial">Just Dial</option>
                                  <option value="Kryzen Website">
                                    Kryzen Website
                                  </option>
                                  <option value="indiaMart">India Mart</option>
                                  <option value="Cheerio">Cheerio</option>
                                  <option value="MyOperator">
                                    My Operator
                                  </option>
                                  <option value="Instagram">Instagram</option>
                                  <option value="Bigin">Bigin</option>
                                  <option value="HM User">Hm User</option>
                                  <option value="Quotation Send">
                                    Quotation Send
                                  </option>
                                  <option value="MissedCall">
                                    Missed Call
                                  </option>
                                  <option value="SiteInspection">
                                    Site Inspection
                                  </option>
                                  <option value="hydroponics_kryzen_com">
                                  Hydroponics Kryzen
                                  </option>
                                </DynamicFilterSelect>
                              </div>
                              <div className="col-12">
                                <div className="form-check">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="emailCheckbox"
                                    name="email"
                                    checked={filters.isEmail || false} // Ensures the checkbox reflects the correct state
                                    onChange={(e) =>
                                      setFilters({
                                        ...filters,
                                        isEmail: e.target.checked, // Set true if checked, false if unchecked
                                      })
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="emailCheckbox"
                                  >
                                    Email
                                  </label>
                                </div>
                              </div>
                              <div className="col-12">
                                <div className="form-check">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="mobileCheckbox"
                                    name="mobile"
                                    checked={filters.isMobile || false} // Ensures the checkbox reflects the correct state
                                    onChange={(e) =>
                                      setFilters({
                                        ...filters,
                                        isMobile: e.target.checked, // Set true if checked, false if unchecked
                                      })
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="mobileCheckbox"
                                  >
                                    Mobile
                                  </label>
                                </div>
                              </div>

                              <div className="col-12">
                                <div className="row mt-2">
                                  <div className="col-6">
                                    <button
                                      onClick={() => setRefresh(!refresh)}
                                      className="btn btn-success w-100"
                                    >
                                      Apply Filter
                                    </button>
                                  </div>
                                  <div className="col-6">
                                    <button
                                      onClick={() => {
                                        setFilters({
                                          startdate: "",
                                          enddate: "",
                                          origin: "",
                                        });
                                        setRefresh(!refresh);
                                      }}
                                      className="btn btn-secondary w-100"
                                    >
                                      Reset Filter
                                    </button>
                                  </div>
                                  <div className="mt-2 col-12">
                                    <button
                                      onClick={handleDownloadCSV}
                                      className={
                                        btnDisable
                                          ? "btn btn-primary disabled"
                                          : "btn btn-primary w-100"
                                      }
                                    >
                                      Download CSV
                                    </button>
                                  </div>
                                  <div className="col-12 mt-2 ">
                                    <div className="card p-2">
                                      Total Count : {totalCount}
                                    </div>
                                  </div>
                                  <div className="col-12 mt-2">
                                    <div className="card p-2">
                                      Filter Count : {filterCount}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="accordion-body d-none d-md-block">
                          <div className="row">
                            <h3>Filter result</h3>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Start Date:"
                                value={filters.startdate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    startdate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="End Date:"
                                value={filters.enddate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    enddate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Origin:"
                                value={filters.origin}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    origin: e.target.value,
                                  })
                                }
                                placeholder="search name..."
                              >
                                <option value="">Select</option>
                                <option value="Facebook Ads">
                                  Facebook Ads
                                </option>
                                <option value="Just Dial">Just Dial</option>
                                <option value="Kryzen Website">
                                  Kryzen Website
                                </option>
                                <option value="indiaMart">India Mart</option>
                                <option value="Cheerio">Cheerio</option>
                                <option value="Instagram">Instagram</option>
                                <option value="MyOperator">My Operator</option>
                                <option value="Bigin">Bigin</option>
                                <option value="HM User">Hm User</option>
                                <option value="Quotation Send">
                                  Quotation Send
                                </option>
                                <option value="MissedCall">Missed Call</option>
                                <option value="SiteInspection">
                                  Site Inspection
                                </option>
                                <option value="hydroponics_kryzen_com">
                                  Hydroponics Kryzen
                                  </option>
                              </DynamicFilterSelect>
                            </div>
                            <div className="col-12">
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="emailCheckbox"
                                  name="email"
                                  checked={filters.isEmail || false} // Ensures the checkbox reflects the correct state
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      isEmail: e.target.checked, // Set true if checked, false if unchecked
                                    })
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="emailCheckbox"
                                >
                                  Email
                                </label>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="mobileCheckbox"
                                  name="mobile"
                                  checked={filters.isMobile || false} // Ensures the checkbox reflects the correct state
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      isMobile: e.target.checked, // Set true if checked, false if unchecked
                                    })
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="mobileCheckbox"
                                >
                                  Mobile
                                </label>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="row mt-2">
                                <div className="col-6">
                                  <button
                                    onClick={() => setRefresh(!refresh)}
                                    className="btn btn-success w-100"
                                  >
                                    Apply Filter
                                  </button>
                                </div>
                                <div className="col-6">
                                  <button
                                    onClick={() => {
                                      setFilters({
                                        startdate: "",
                                        enddate: "",
                                        origin: "",
                                      });
                                      setRefresh(!refresh);
                                    }}
                                    className="btn btn-secondary w-100"
                                  >
                                    Reset Filter
                                  </button>
                                </div>
                                <div className="mt-2 col-12">
                                  <button
                                    onClick={handleDownloadCSV}
                                    className={
                                      btnDisable
                                        ? "btn btn-primary disabled"
                                        : "btn btn-primary w-100"
                                    }
                                  >
                                    Download CSV
                                  </button>
                                </div>
                                <div className="col-12 mt-2 ">
                                  <div className="card p-2">
                                    Total Count : {totalCount}
                                  </div>
                                </div>
                                <div className="col-12 mt-2">
                                  <div className="card p-2">
                                    Filter Count : {filterCount}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-9 col-sm-12 py-2">
                  {loading ? (
                    <LoadingPage />
                  ) : (
                    <div className="card">
                      {data && data?.marketingListData && (
                        <MarketingTable
                          data={data?.marketingListData}
                          currentPage={page}
                          itemsPerPage={50}
                        />
                      )}
                    </div>
                  )}

                  <Pagination
                    page={page}
                    setPage={setPage}
                    totalPages={totalPages}
                    pageDatalength={data?.marketingListData?.length}
                    showPage={showPage}
                    setShowPage={setShowPage}
                  />
                </div>
                <div className="col-auto ms-auto">
                  <div className="d-flex d-lg-none d-md-none d-sm-block">
                    <button
                      onClick={() => Navigate("/email-marketing")}
                      className="btn btn-danger me-3"
                    >
                      <LuMail className="fs-2 me-1" />
                      Send Email
                    </button>
                    <WhatsAppButton buttonText="Send Watsapp" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default MarketingSystem;
